import { useState } from "react";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionTag } from "./SectionTag";

const faqs = [
  {
    q: "Combien ça coûte ?",
    a: "34,99€/mois en Standard, 99€/mois en Pro (avec en plus une page vitrine publique pour votre commerce). Pour des besoins spécifiques, on construit un tarif sur mesure avec vous en démo.",
  },
  {
    q: "Mes clients doivent-ils télécharger une application ?",
    a: "Non. Ils scannent le QR fourni par Wara Cards, et leur carte s'ajoute automatiquement à Apple ou Google Wallet — aucune application à télécharger. Vous récupérez leur fiche client directement dans votre tableau de bord dès la création de la carte.",
  },
  {
    q: "Ça marche avec ma caisse actuelle ?",
    a: "Oui, sans aucune intégration technique. Vous ajoutez le tampon en un clic depuis votre tableau de bord commerçant à chaque passage — la mise à jour arrive en temps réel sur la carte de votre client.",
  },
  {
    q: "Et si un client laisse un avis négatif ?",
    a: "Le routage intelligent des avis intercepte les clients mécontents avant publication et les redirige vers un formulaire privé, pendant que vos clients satisfaits sont invités à laisser un avis public.",
  },
  {
    q: "Combien de temps faut-il pour lancer mon programme ?",
    a: "Avec l'onboarding concierge, votre carte est configurée pour vous et prête en moins de 20 minutes.",
  },
  {
    q: "Les notifications push (relance) sont-elles disponibles ?",
    a: "Oui, dès aujourd'hui. Elles arrivent directement sur l'écran verrouillé du téléphone de vos clients — gratuites et illimitées, là où 200 SMS vous coûteraient environ 7€ à chaque envoi.",
  },
  {
    q: "Les cartes à tampon papier, ça suffit non ?",
    a: "Le papier se perd, s'oublie, et ne vous donne aucune coordonnée client. La carte digitale reste dans la poche, ne se perd jamais, et capte automatiquement email et téléphone dès le premier passage.",
  },
];

export function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-cream-deep py-24">
      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <Reveal className="text-center">
          <SectionTag>FAQ</SectionTag>
          <h2 className="mt-5 text-4xl font-extrabold tracking-tight text-ink lg:text-5xl">
            Questions fréquentes
          </h2>
          <p className="mt-4 text-lg text-ink-soft">
            Tout ce que vous devez savoir avant de vous lancer.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 divide-y divide-line rounded-2xl border border-line bg-white shadow-card">
            {faqs.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={item.q} className="px-6">
                  <button
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="flex w-full items-center justify-between gap-4 py-5 text-left"
                  >
                    <span className="font-semibold text-ink">{item.q}</span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-cream-deep transition-transform ${
                        isOpen ? "rotate-45" : ""
                      }`}
                    >
                      <Plus size={16} />
                    </span>
                  </button>
                  {isOpen && (
                    <p className="pb-5 text-sm leading-relaxed text-ink-soft">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </Reveal>

        <Reveal delay={0.15} className="mt-8 text-center">
          <p className="text-sm text-ink-soft">
            Une autre question ?{" "}
            <a href="#demo" className="font-semibold text-coral hover:underline">
              Contactez-nous →
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
